import {
  ConversationMessagesAppParams,
  EMessengerAppName,
  PinnedMessagesAppParams,
  TMessengerAppParams,
} from '@xometry/ui';
import type { TErpMainMessengerHostAppParams } from 'utils/messenger/buildErpMainMessengerMicroFrontendProps';

export const MICRO_FRONTEND_NAME = {
  Messenger: 'Messenger',
  PinnedMessages: 'PinnedMessages',
  ConversationMessages: 'ConversationMessages',
} as const;

export type MicroFrontendName = (typeof MICRO_FRONTEND_NAME)[keyof typeof MICRO_FRONTEND_NAME];

interface AppParamsByName {
  [MICRO_FRONTEND_NAME.Messenger]:
    | TErpMainMessengerHostAppParams
    | TMessengerAppParams<EMessengerAppName.ERP_DOCUMENT_PAGE>;
  [MICRO_FRONTEND_NAME.PinnedMessages]: PinnedMessagesAppParams;
  [MICRO_FRONTEND_NAME.ConversationMessages]: ConversationMessagesAppParams;
}

interface CommonProps {
  containerId: string;
  host: string;
  onRender?: () => void;
}

export type MicroFrontendProps = {
  [N in keyof AppParamsByName]: CommonProps & {
    name: N;
    appParams: AppParamsByName[N];
  };
}[keyof AppParamsByName];

export interface TManifest {
  files: Record<string, string>;
}

export type RenderFn = (containerId: string, appParams: unknown) => void;
export type UnmountFn = (containerId: string) => void;
